import script from "./AdminTopOper.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTopOper.vue?vue&type=script&setup=true&lang=js"

import "./AdminTopOper.vue?vue&type=style&index=0&id=e66384ee&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\wxPrint2\\adminVue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e66384ee"]])

export default __exports__